import React, { ReactElement, FunctionComponent, memo } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import LabelFont from '../../../Theme/Fonts/Label'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'

export type DurationLabelSizes = 'S' | 'M'

export type Duration = {
    /**
     * duration as string
     * */
    duration: string
    /**
     * sets size of label
     * */
    size?: DurationLabelSizes
    children?: never
    /**
     * adds a "play-active" icon to the label
     * */
    withIcon?: boolean
}

type labelComponentProps = {
    duration: string
}

export const LabelComponentS: FunctionComponent<labelComponentProps> = ({ duration }) => (
    <LabelFont color="WHITE" uppercase bold>
        {duration}
    </LabelFont>
)

export const LabelComponentM: FunctionComponent<labelComponentProps> = ({ duration }) => (
    <SmallBodyFont color="WHITE" bold>
        {duration}
    </SmallBodyFont>
)

const DurationLabel: FunctionComponent<Duration> = ({
    duration,
    size = 'S',
    withIcon,
}): ReactElement => (
    <Grid horizontal noExpand>
        <Grid
            height={size === 'M' ? 20 : 18}
            noExpand
            paddingLeft={2}
            paddingRight={2}
            backgroundColor="BLACK"
            borderRadius={1}
            center
            horizontal
        >
            {withIcon ? (
                <FontelloIcon name="play-active" color="WHITE" fontSize={10} marginRight={2} />
            ) : null}
            {size === 'M' ? (
                <LabelComponentM duration={duration} />
            ) : (
                <LabelComponentS duration={duration} />
            )}
        </Grid>
    </Grid>
)

export default memo(DurationLabel)
